import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';

const InvestigationsIntro = function () {
  return (
    <div>
      <h1 className="section-header">{i18n.t('legal.pvq.investigations.heading.title')}</h1>
      <Field optional className="no-margin-bottom">
        {i18n.m('legal.pvq.investigations.para.intro1')}
        {i18n.m('legal.pvq.investigations.para.intro2')}
        {i18n.m('legal.pvq.investigations.para.intro3')}
        {i18n.m('legal.pvq.investigations.para.intro4')}
        {i18n.m('legal.pvq.investigations.para.intro5')}
      </Field>
    </div>
  );
};

export default InvestigationsIntro;
